import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex h-full items-stretch"
};
import Mode from './mode/index.vue';
import List from './list/index.vue';
import { ref, unref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'Index'
  },
  __name: 'index',
  setup(__props) {
    const listRef = ref(null);
    /*
     *@Description: 拿到左侧配置信息调用右侧音乐生成的方法
     *@MethodAuthor: xiaohong
     *@Date: 2024-07-19 11:13:38
    */
    function generateMusic(args) {
      unref(listRef)?.generateMusic(args.formData);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Mode, {
        class: "flex-none",
        onGenerateMusic: generateMusic
      }), _createVNode(List, {
        ref_key: "listRef",
        ref: listRef,
        class: "flex-auto"
      }, null, 512)]);
    };
  }
});